export default __webpack_public_path__ + "static/media/logo_jalin 1.72457d2b.svg";